import AlertDialog from './alert';
import ConfirmDialog from './confirm';
import CustomDialog from './custom';
import PortalDialog from './portalDialog';
import PortalDialogWrapper from './portalDialogWrapper';
import NormalDialog from './normalDialog';
import modalServiceWrapper from './modalServiceWrapper';

export {
    AlertDialog,
    ConfirmDialog,
    CustomDialog,
    PortalDialog,
    PortalDialogWrapper,
    NormalDialog,
    modalServiceWrapper,
};
